var _excluded = ["disabled", "label", "value", "onChange", "style", "className", "shouldValidateEmail"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { Grid, FormControl, TextField, InputLabel } from '@mui/material';
import clsx from 'clsx';
import { red } from '@mui/material/colors';
import { useTranslation } from 'react-i18next';
import CheckIcon from '@mui/icons-material/Check';
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';
import { controlLabelStyles, controlFormStyles, validateEmail } from "../../common";
var PREFIX = 'BrandInput';
var classes = {
  transferOwnerShipBtn: "".concat(PREFIX, "-transferOwnerShipBtn"),
  controlLabel: "".concat(PREFIX, "-controlLabel"),
  formControl: "".concat(PREFIX, "-formControl"),
  disabled: "".concat(PREFIX, "-disabled"),
  fullWidthInput: "".concat(PREFIX, "-fullWidthInput"),
  gridItem: "".concat(PREFIX, "-gridItem"),
  input: "".concat(PREFIX, "-input"),
  hasError: "".concat(PREFIX, "-hasError")
};
var StyledGrid = styled(Grid)(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref2, "& .".concat(classes.transferOwnerShipBtn), {
    height: '50px',
    gridColumnStart: 2,
    justifySelf: 'center',
    alignSelf: 'flex-end',
    textTransform: 'none'
  }), "& .".concat(classes.controlLabel), _objectSpread(_objectSpread({}, controlLabelStyles(theme)), {}, {
    fontWeight: '400'
  })), "& .".concat(classes.formControl), controlFormStyles(theme)), "& .".concat(classes.disabled), {
    color: theme.palette.font.primary,
    opacity: 0.6
  }), "& .".concat(classes.fullWidthInput), {
    width: '100%'
  }), "& .".concat(classes.gridItem), {
    width: '100%'
  }), "& .".concat(classes.input), {
    '&::placeholder': {
      opacity: 0.9
    }
  }), "& .".concat(classes.formControl), {
    background: theme.palette.inputField.primary,
    '&::placeholder': {
      fontSize: '1rem',
      opacity: 0.8
    }
  }), '& .BrandInput-disabled', {
    WebkitTextFillColor: "".concat(theme.palette.font.primary, " !important"),
    opacity: 0.5
  }), '& .BrandInput-disabled > input', {
    opacity: 1
  }), _defineProperty(_defineProperty(_defineProperty(_ref2, '& .BrandInput-disabled > textarea', {
    opacity: 1
  }), '& .Mui-error', {
    border: 'none'
  }), "& .".concat(classes.hasError), {
    color: red[700]
  });
});
var BrandInput = function BrandInput(_ref3) {
  var disabled = _ref3.disabled,
    label = _ref3.label,
    value = _ref3.value,
    onChange = _ref3.onChange,
    style = _ref3.style,
    className = _ref3.className,
    shouldValidateEmail = _ref3.shouldValidateEmail,
    props = _objectWithoutProperties(_ref3, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    fieldError = _useState2[0],
    setFieldError = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showPassword = _useState4[0],
    setShowPassword = _useState4[1];
  useEffect(function () {
    if (value && shouldValidateEmail && !validateEmail(value)) {
      setFieldError(t('please_enter_a_valid_email'));
    }
    if (!value || value && shouldValidateEmail && validateEmail(value)) {
      setFieldError('');
    }
  }, [value, shouldValidateEmail, t]);
  var getEndAdornment = function getEndAdornment() {
    if (value && shouldValidateEmail && validateEmail(value)) {
      return /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(CheckIcon, {
        size: "small"
      }));
    }
    if (props.type === 'password') {
      return /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(IconButton, {
        onClick: function onClick() {
          return setShowPassword(!showPassword);
        }
      }, showPassword ? /*#__PURE__*/React.createElement(Visibility, {
        size: "small",
        style: {
          color: '#046FFF'
        }
      }) : /*#__PURE__*/React.createElement(VisibilityOff, {
        size: "small",
        style: {
          color: '#046FFF'
        }
      })));
    }
    return null;
  };
  return /*#__PURE__*/React.createElement(StyledGrid, {
    item: true,
    container: true,
    direction: "column",
    className: "".concat(classes.gridItem, " ").concat(className),
    style: style
  }, label && /*#__PURE__*/React.createElement(InputLabel, {
    className: clsx(classes.controlLabel, _defineProperty({}, classes.hasError, props.error)),
    color: "primary"
  }, label), /*#__PURE__*/React.createElement(FormControl, {
    className: classes.fullWidthInput
  }, /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
    type: showPassword ? 'text' : props.type,
    error: !!fieldError || !!props.error,
    helperText: (!!fieldError || !!props.error) && (fieldError || props.helperText),
    disabled: disabled,
    size: "small",
    variant: "outlined",
    InputProps: {
      className: classes.formControl,
      classes: {
        disabled: classes.disabled,
        input: classes.input
      },
      endAdornment: getEndAdornment()
    },
    onChange: onChange,
    value: value || ''
  }))));
};
BrandInput.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.any,
  value: PropTypes.any,
  style: PropTypes.object,
  className: PropTypes.string,
  shouldValidateEmail: PropTypes.bool
};
export default BrandInput;